<form>
	<ul *ngIf="checkboxUsers.length" class="unstyled">
		<li class="select-all">
			<label class="img-checkbox">
				<input id="user_all" type="checkbox" name="user_all"  (change)="checkAll($event.target)">
				<label for="user_all">
					<svg-checked></svg-checked>
				</label>
			</label>
			<span>Select all Users</span>
		</li>
		<li *ngFor="let user of checkboxUsers">
			<label class="img-checkbox">
				<input id="user_{{user.id}}" [(ngModel)]="user.checked" type="checkbox" name="user_{{user.id}}">
				<label [title]="user.name" for="user_{{user.id}}">
					<svg-checked></svg-checked>
				</label>
			</label>
			<span>{{user.name}}</span>
		</li>
	</ul>
</form>
<spinner [spinnerShow]="isShowSpinner"></spinner>



// WEBPACK FOOTER //
// /app/src/app/views/dashboard/dashboard-users-modal/dashboard-users-modal.component.html